import React, { useMemo } from 'react';
import { CustomButton } from 'shared_ui_components';
import styles from './Common.module.scss';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import useSubmitRolePlayMutation from 'features/realplays/services/mutations/useSubmitRoleplay';
import iconSubmit from 'assets/roleplay/iconSubmit.svg';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const SubmitRealplayBody = () => {
  let location = useLocation();
  let history = useHistory();
  const { uuid } = useParams();

  const { roleplay, scenarios } = RealPlayRecordDataHelper();

  const scenarios_response = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return false;
    //TODO: add response retaken.
    return scenarios?.map((sce) => ({
      scenario_uuid: sce?.uuid,
      response_uuid: sce?.response?.uuid,
    }));
  }, [scenarios]);

  const { mutate: submitRoleplay, isLoading } = useSubmitRolePlayMutation();

  const handleSubmit = () => {
    submitRoleplay(
      { assignment_uuid: uuid, title: roleplay?.name, scenarios_response },
      {
        onSuccess: (response) => {
          history.push({
            pathname: `/roleplay`,
            state: {
              prevPath: `${location.pathname}${location.search ? location.search : ''}`,
            },
          });
        },
      }
    );
  };

  const enabled = useMemo(
    () => scenarios?.every((item) => item.response && item.response.video),
    [scenarios]
  );

  return (
    <div>
      {scenarios.map((scenario, index) => {
        const completed = scenario.response.video ? true : false;
        const title = scenario.is_default === false ? scenario.name : roleplay?.name;
        const description = scenario.description ? scenario.description : roleplay?.description;
        return (
          <div className={styles.cardContainer} key={index}>
            <div className={styles.cardTitle}>
              <div
                className={`${styles.cardIndex} ${!completed ? styles.cardIndexUncompleted : ''}`}
              >
                <strong>{index + 1}</strong>
              </div>
              <img src={iconSubmit} alt="icon" className={`${styles.cardIcon}`} />
              <div className="heading6">{title}</div>
            </div>

            <div className="supportText">{description}</div>
          </div>
        );
      })}
      <div className={styles.submitButton}>
        <CustomButton onClick={handleSubmit} disabled={!enabled || isLoading}>
          Submit
        </CustomButton>
      </div>
    </div>
  );
};

export default SubmitRealplayBody;
